import es from './es.json';
import en from './en.json';

export const translations: Record<string, typeof en> = {
  es,
  en
};

export type TranslationKeys = typeof en;
